import AvisVerifiesIcon from '@assets/svg/icons/avis-verifies.svg'
import PlayStoreIcon from '@assets/svg/icons/play-store.svg'
import TrustpilotIcon from '@assets/svg/icons/trustpilot.svg'
import { ContentType } from '@entries/content-types'
import ContentfulFootnoteSup from '@entries/contentful-footnote-sup'
import IconApple from '@fortuneo/ui-icons/general/IconApple'
import IconStar from '@fortuneo/ui-icons/general/IconStar'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { type IPlatformScoreFields } from '@typings/contentful.readonly'
import { graphql } from 'gatsby'
import React from 'react'

type PlatformData = {
  icon: any
  label: string
}

const platformsData: Utils.Object<
  PlatformData,
  IPlatformScoreFields['platform'] | string
> = {
  'avis-vérifiés': {
    icon: AvisVerifiesIcon,
    label: 'Avis Vérifiés',
  },
  trustpilot: {
    icon: TrustpilotIcon,
    label: 'Trustpilot',
  },
  'app-store': {
    icon: IconApple,
    label: 'App Store',
  },
  'play-store': {
    icon: PlayStoreIcon,
    label: 'Play Store',
  },
}

const ContentfulPlatformScore: Utils.EntryFC<
  Queries.ContentfulPlatformScoreFragment
> = ({ content: { score, platform, legalMention }, entryInspectorProps }) => {
  const { icon: PlatformIcon, label } = platformsData[platform]

  return (
    <div className="flex flex-col items-center" {...entryInspectorProps()}>
      <div className="flex items-center">
        <span className="mr-2 text-135 font-medium">
          {score.toLocaleString('fr-FR')}
        </span>
        <IconStar />
      </div>
      <div className="mt-3 flex items-stretch">
        <PlatformIcon height={16} />
        <p className="ml-1">
          {label}
          <Entry
            content={legalMention}
            mapping={{
              [ContentType.ContentfulFootnote]: ContentfulFootnoteSup,
            }}
          />
        </p>
      </div>
    </div>
  )
}

export const query = graphql`
  fragment ContentfulPlatformScore on ContentfulPlatformScore {
    ...ContentfulEntry
    platform
    score
    legalMention {
      ...ContentfulFootnoteSup
    }
  }
`

export default withDisplayName(
  ContentfulPlatformScore,
  'ContentfulPlatformScore'
)
